// piezeo-sensor.component.ts
import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GaugeChartComponent } from "../../device-detail-nxt/gauge-chart-component/gauge-chart-component.component";
import {
  NgApexchartsModule,
  ApexAxisChartSeries,
  ApexChart,
  ApexPlotOptions,
  ApexFill,
  ApexDataLabels,
  ApexGrid,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis
} from 'ng-apexcharts';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from "@angular/router";
import { BackendApiService } from '../../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../../app/services/base-url-constants.service';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { ConvertDatetimePipe } from '../../../../app/convert-datetime.pipe';
import { MatDialog } from '@angular/material/dialog';
import { SettingsModalComponent } from '../../../../app/components/settings-modal/settings-modal.component';
import { DialogOverviewExampleDialogComponent } from '../../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { ServiceStatusSettingsComponent } from '../piezo-sensor-dashboard/service-status-settings/service-status-settings.component';
import { PiezeoDashboardService } from '../../../../app/services/piezo-dashboard.service';
@Component({
  selector: 'app-piezeo-sensor-monitoring',
  standalone: true,
  imports: [CommonModule, GaugeChartComponent, NgApexchartsModule, MatIcon, MatButtonModule, MatIconModule, FormsModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatNativeDateModule],
  templateUrl: './piezeo-monitoring.component.html',
  styleUrls: ['./piezeo-monitoring.component.scss']
})
export class PiezeoSensorMonitoringComponent implements OnInit {
  @Input() data: any;
  public isDark: boolean = false;
  public bhelOnPrem: boolean = BaseUrlConstantsService.BHEL_ON_PREM;
  public selectedFilter: string = 'velocity'; // default to velocity
  public selectedAxis: string = '';
  public availableAxis: string[] = [];
  public selectedTimeFilter: string = 'hourly';
  lightLegendColors = ['#4caf50', '#ff9800', '#f44336'];
  darkLegendColors = ['#72ff13', '#faa700', '#ff2a1b'];
  public subsystemId: number = 0;
  public clientId = localStorage.getItem('user_id');
  public gatewayAddress: string = '';
  public axis: string = '';
  public loadingVibration: boolean = true;
  public loadingTemperature: boolean = true;
  public loadingBucket: boolean = true;
  public loadingAnomalyStatus: boolean = true;
  public loadingService: boolean = false;
  public serviceData: any = null;
  public bucketArray: any[] = [];
  public showTrendsChart: boolean = false;
  public startDate: string = '';
  public endDate: string = '';
  public lastUpdatedAt: string = '';
  public anomalyStatus: string = '';
  public recommendedAction: string = 'N/A'
  public actionClass = "";
  public anomalyActionClass = "";
  public loadingOperationalSummary = true;
  public noOfStops: number = 0;
  public machineUtilization: number = 0;
  public weeklyRunTime: string = "";
  public loadingAlerts: boolean = true;
  public alerts: any[] = [];
  public loadingCompanyDetails: boolean = true;
  public companyName: string = "";
  public siteName: string = "";
  public applicationName: string = "";
  public serialNumber: string = "";
  public assetName: string = "";
  public loadingServiceData: boolean = true;
  public lastServiceDate: string = "";
  public servicePerformed: string = "";
  public nextServiceDate: string = "";
  private refreshTimeout: any;
  private refreshBucketTimeout: any;
  private loadingDeviceStatus: boolean = true;
  public deviceStatus: string = "";
  public lastFileTime: string = "";

  // public filterGaugePararm: any = this.data;

  // Trends chart data

  @Output() navigateToTab = new EventEmitter<string>();

  public trendsData: any = {
    velocity: null,
    acceleration: null,
    displacement: null,
    temperature: null
  };

  public trendsLoading: any = {
    velocity: false,
    acceleration: false,
    displacement: false,
    temperature: false
  };

  constructor(
    private service: BackendApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog
  ) {
  }

  powertrain_generate_report_url = BaseUrlConstantsService.ASSET_REPORT_PDF;
  report_preview_generate = BaseUrlConstantsService.Generate_new_url;
  report_generate = BaseUrlConstantsService.ASSET_REPORT_PDF;
  assetServiceUrl = BaseUrlConstantsService.BASE_ASSET_SERVICE;
  public BHEL_ON_PREM: boolean = BaseUrlConstantsService.BHEL_ON_PREM;
  isReportModalOpen: boolean = false;
  isLoading: boolean = false;
  today = new Date();
  reportSize = "2.4 MB";
  currentStep = 1;
  progressPercentage = 0;
  processingStepText = "Collecting Data";
  SAONDEMANDRESPONSE: any;
  isDownloading: boolean = false;
  public token: any = localStorage.getItem("token") || "not available";
  private processingTimers: any[] = [];

  axisVibrationGauge = [
    {
      name: 'Acceleration',
      type: 'acceleration',
      value: null,
      bottomLabel: 'N/A',
      options: this.getDefaultGaugeOptions(),
      isActive: false
    },
    {
      name: 'Velocity',
      type: 'velocity',
      value: null,
      bottomLabel: 'N/A',
      options: this.getDefaultGaugeOptions(),
      isActive: false
    },
    {
      name: 'Displacement',
      type: 'displacement',
      value: null,
      bottomLabel: 'N/A',
      options: this.getDefaultGaugeOptions(),
      isActive: false
    },
  ]

  // Machine Vibration gauges - initialize based on axis
  machineVibration = [
    {
      name: 'Radial (Horizontal)',
      value: null,
      bottomLabel: 'N/A',
      options: this.getDefaultGaugeOptions(),
      isActive: false
    },
    {
      name: 'Tangential (Vertical)',
      value: null,
      bottomLabel: 'N/A',
      options: this.getDefaultGaugeOptions(),
      isActive: false
    },
    {
      name: 'Axial',
      value: null,
      bottomLabel: 'N/A',
      options: this.getDefaultGaugeOptions(),
      isActive: false
    },
  ];

  // Temperature gauge
  temperature = {
    name: 'Bearing Temperature',
    value: null,
    bottomLabel: 'N/A',
    options: {
      arcColors: ['#74fa18', '#faa700', '#f3291c'],
      arcDelimiters: [60, 80],
      arcLabels: [60, 80],
      hasNeedle: false,
      needleColor: '#cecece',
      rangeLabel: ['0', '100']
    }
  };

  // Machine Health Status chart options
  public healthStatusOptions: {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    plotOptions: ApexPlotOptions;
    colors: string[];
    dataLabels: ApexDataLabels;
    grid: ApexGrid;
    tooltip: ApexTooltip;
    xaxis: ApexXAxis;
    yaxis: ApexYAxis;
    legend: any;
    fill: ApexFill;
  } = {
      series: [],
      chart: {
        type: 'bar',
        height: 150,
        width: 800,
        stacked: true,
        toolbar: { show: false },
        background: 'transparent',
        zoom: { enabled: false },
        animations: { enabled: false }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 2,
          columnWidth: '90%',
          dataLabels: { total: { enabled: false } }
        }
      },
      colors: ['#74fa18', '#faa700', '#f3291c', '#999999', '#cecece'],
      dataLabels: { enabled: false },
      grid: { show: false },
      tooltip: {
        enabled: true,
        shared: false,
        intersect: true,
        y: {
          formatter: (val: number, opts: any) =>
            val === 1 ? opts.w.globals.seriesNames[opts.seriesIndex] : ''
        }
      },
      xaxis: {
        categories: [],
        labels: { show: false },
        axisBorder: { show: false },
        axisTicks: { show: false }
      },
      yaxis: {
        min: 0,
        max: 1.001,
        tickAmount: 1,
        labels: { show: false },
        axisBorder: { show: false },
        axisTicks: { show: false }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'center',
        fontSize: '12px',
        markers: {
          width: 8,
          height: 8,
          radius: 2,
          fillColors: ['#74fa18', '#faa700', '#f3291c', '#999999', '#cecece']
        },
        labels: { colors: '#ccc' }
      },
      fill: { opacity: 1 }
    };

  http = inject(BackendApiService);
  piezo_service = inject(PiezeoDashboardService);
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data) {
      console.log('Data changed, re-identifying axes...');
      this.identifyAvailableAxis();
      // Optional: If you want to auto-select X if the current selection became invalid
      if (!this.availableAxis.includes(this.selectedAxis) && this.availableAxis.length > 0) {
        this.selectedAxis = this.availableAxis[0];
        this.triggerAllFetch();
      }
    }
  }

  ngOnInit(): void {
    console.log("----------Prop of mon:", this.data);
    // this.resetVibrationGauges();
    // Initialize gauges
    // this.machineVibration.forEach(gauge => {
    //   gauge.isActive = false;
    //   gauge.value = 0;
    //   gauge.bottomLabel = '0.00 m/sec²';
    //   gauge.options = {
    //     ...this.getDefaultGaugeOptions(),
    //     hasNeedle: true
    //   };
    // });

    if (this.data) {
      this.clientId = this.data.clientId;
      this.identifyAvailableAxis();
      this.triggerAllFetch(); // initial call
      this.triggerHealthBarFetch();
    } else {
      console.error('Component data not received');
    }
    console.log("3555555555555555555555555780")
    console.log(this.piezo_service.getSubsystemData())
    this.subsystemId = this.piezo_service.getSubsystemData().id;
  }

  identifyAvailableAxis() {
    const sensors_info = this.data?.sensors_info || {};
    const foundAxes = new Set<string>();

    Object.keys(sensors_info).forEach(key => {
      // Look for keys like 'sensor_1_axis', 'sensor_2_axis'
      if (key.includes('_axis')) {
        const axisVal = sensors_info[key];
        // FIX: Convert to UpperCase so 'x' becomes 'X'
        if (axisVal) {
          foundAxes.add(String(axisVal).toUpperCase());
        }
      }
    });

    this.availableAxis = Array.from(foundAxes);
    this.availableAxis.sort();

    console.log("Available Axes found:", this.availableAxis);

    // Set default axis if none selected or current selection is invalid
    if (!this.selectedAxis || !this.availableAxis.includes(this.selectedAxis)) {
      if (this.availableAxis.length > 0) {
        this.selectedAxis = this.availableAxis[0];
      }
    }
  }
  async fetchDeviceStatus() {
    try {
      this.loadingDeviceStatus = true;
      const apiUrl = `${BaseUrlConstantsService.GET_PIEZO_DEVICE_STATUS}${this.data.macAddress}`
      const response: any = await this.service.getDataV2(apiUrl);
      if (response?.error === false) {
        let tempStatus = response.onlineStatus;
        switch (tempStatus) {
          case 0:
          case 1:
            this.deviceStatus = "ONLINE";
            break;
          case 2:
            this.deviceStatus = "OFFLINE";
            break;
          default:
            this.deviceStatus = "N/A";
            break;
        }
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.loadingDeviceStatus = false;
    }
  }

  async openSettingsModal() {
    this.fetchDeviceStatus();
    try {
      const apiUrl = `${BaseUrlConstantsService.ASSET_METRICS}`;
      const response: any = await this.service.postData(apiUrl, { asset_id: this.data.assetId, user_id: `22${this.clientId}2222` });
      if (response?.data?.status === "success" && response?.data?.body.length > 0) {
        this.dialog.open(SettingsModalComponent, {
          width: "1200px",
          data: {
            metrics: response.data.body,
            deviceStatus: this.deviceStatus,
            lastFileTime: this.lastFileTime,
            assetId: this.data.assetId
          }
        });
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  triggerAllFetch() {
    this.fetchVibrationGaugeData();
    this.fetchTemperatureGaugeData();
    this.fetchAnomalyStatus();
    this.fetchOperationalSummary();
    this.fetchAlerts();
    this.fetchCompanyDetails();
    this.fetchServiceData();

    // Call again after 30s
    this.refreshTimeout = setTimeout(() => {
      this.triggerAllFetch();
    }, 30000); // 30 sec
  }

  triggerHealthBarFetch() {
    this.fetchBucketData();
    this.refreshBucketTimeout = setTimeout(() => {
      this.triggerHealthBarFetch();
    }, 120000);
  }

  ngOnDestroy(): void {
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }
    if (this.refreshBucketTimeout) {
      clearTimeout(this.refreshBucketTimeout);
    }
  }

  private getDefaultGaugeOptions() {
    return {
      arcColors: ['#72FF13', '#FAA700', '#ff2a1b'],
      arcDelimiters: [30, 70],
      arcLabels: [30, 70],
      hasNeedle: false,
      needleColor: '#cecece',
      rangeLabel: ['0', '100'],
    };
  }


  // Filter button methods
  onFilterChange(filterType: 'acceleration' | 'velocity' | 'displacement'): void {
    this.selectedFilter = filterType;
    this.loadingVibration = true;
    this.fetchVibrationGaugeData();
  }

  onAxisChange(axis: string): void {
    if (!this.availableAxis.includes(axis)) return;
    this.selectedAxis = axis;
    this.loadingVibration = true;
    this.fetchVibrationGaugeData();
  }

  private resetVibrationGauges(): void {
    this.axisVibrationGauge.forEach(gauge => {
      gauge.isActive = false;
      gauge.value = 0;
      gauge.bottomLabel = 'N/A';
      gauge.options = { ...this.getDefaultGaugeOptions(), hasNeedle: false };
    });
  }

  async fetchVibrationGaugeData() {
    if (!this.selectedAxis) {
      this.loadingVibration = false;
      return;
    }
    try {
      const accId = this.getChannelIdForAxis('acceleration');
      const velId = this.getChannelIdForAxis('velocity');
      const dispId = this.getChannelIdForAxis('displacement');

      const channels = [accId, velId, dispId].filter(id => id !== null);

      if (channels.length === 0) {
        console.warn(`No channels found for Axis ${this.selectedAxis}`);
        this.resetVibrationGauges();
        this.loadingVibration = false;
        return;
      }
      const channelsParam = channels.join(',');
      const apiUrl = `${BaseUrlConstantsService.GET_PIEZO_VIBRATION_GAUGE}${this.clientId}/${channelsParam}/${this.data.assetId}`
      // const apiUrl = `http://localhost:9001/gauges/${this.clientId}/${channelsParam}/${this.data.assetId}`
      const vibrationResponse: any = await this.service.getDataV2(apiUrl);

      if (vibrationResponse?.error === false && vibrationResponse?.data && Array.isArray(vibrationResponse.data)) {
        this.updateVibrationGauges(vibrationResponse.data, accId, velId, dispId);
      }
      else {
        console.warn('No valid vibration data received');
        this.resetActiveGauge();
      }
    } catch (error) {
      console.error('Error fetching vibration data:', error);
      this.resetActiveGauge();
    } finally {
      this.loadingVibration = false;
    }
  }

  private getChannelIdForAxis(type: 'velocity' | 'acceleration' | 'displacement'): any {
    const sensors_info = this.data.sensors_info || {};

    // 1. Collect all available axes from the response
    const availableAxes: string[] = [];
    for (let i = 1; i <= 10; i++) {
      const axis = sensors_info[`sensor_${i}_axis`];
      if (axis) {
        availableAxes.push(String(axis).toUpperCase().trim());
      }
    }

    // 2. Sort them to match the API's standard return order (X, Y, Z)
    availableAxes.sort();

    // 3. Find the index of the currently selected axis in this sorted list
    // Example: if axes are ['X', 'Y', 'Z'] and selected is 'X', index is 0.
    const axisIndex = availableAxes.indexOf(this.selectedAxis);

    if (axisIndex === -1) return null;

    // 4. Use this index to pick from the channel arrays
    if (type === 'velocity') return this.data.velocityChannels?.[axisIndex];
    if (type === 'acceleration') return this.data.accelerationChannels?.[axisIndex];
    if (type === 'displacement') return this.data.displacementChannels?.[axisIndex];

    return null;
  }


  private updateVibrationGauges(dataArray: any[], accId: any, velId: any, dispId: any): void {
    console.log("Update vibration gauges");
    console.log(dataArray);

    this.resetVibrationGauges();

    dataArray.forEach(item => {
      let targetGauge = null;

      // Normalize key to lower case for safer matching
      const key = (item.key || '').toLowerCase();

      // Match based on keywords in the key property
      if (key.includes('acceleration')) {
        targetGauge = this.axisVibrationGauge[0]; // Acceleration
      }
      else if (key.includes('velocity')) {
        targetGauge = this.axisVibrationGauge[1]; // Velocity
      }
      else if (key.includes('displacement')) {
        targetGauge = this.axisVibrationGauge[2]; // Displacement
      }

      console.log(`Item Key: ${key} -> Target Gauge:`, targetGauge ? targetGauge.name : 'None');

      if (targetGauge) {
        this.setGaugeData(targetGauge, item);
      }
    });
  }

  private setGaugeData(gauge: any, item: any) {
    const value = parseFloat(item.value) || 0;
    const maxRange = parseFloat(item.rangelabel?.[1]) || 100;

    let percentageDelimiters: number[] = [];
    let absoluteDelimiters: number[] = [];

    // Check if we have delimiters from API
    if (item.arcDelimiters && item.arcDelimiters.length > 0) {
      if (gauge.type === 'velocity') {
        // CASE 1: Velocity (API sends Absolute Values, e.g., 1.5, 2.5)
        absoluteDelimiters = item.arcDelimiters.map((val: any) => Number(val));

        // Convert to % for the gauge drawing
        percentageDelimiters = absoluteDelimiters.map(val => (val / maxRange) * 100);
      } else {
        // CASE 2: Acceleration/Displacement (API sends Percentages, e.g., 70, 85)
        percentageDelimiters = item.arcDelimiters.map((val: any) => Number(val));

        // Calculate absolute values
        absoluteDelimiters = percentageDelimiters.map(val => {
          const rawAbs = (val / 100) * maxRange;
          // CRITICAL FIX: Round to 1 decimal place so it matches the gauge ticks (0.1 steps)
          // 2.52 -> 2.5 (Visible)
          // 3.06 -> 3.1 (Visible)
          return parseFloat(rawAbs.toFixed(1));
        });
      }
    } else {
      // Fallback defaults
      percentageDelimiters = [30, 70];
      absoluteDelimiters = [parseFloat((maxRange * 0.3).toFixed(1)), parseFloat((maxRange * 0.7).toFixed(1))];
    }

    gauge.isActive = true;
    gauge.value = value.toFixed(2);
    gauge.bottomLabel = `${value.toFixed(2)} ${item.icon || ''}`;

    gauge.options = {
      arcColors: ['#72FF13', '#FAA700', '#ff2a1b'],
      arcDelimiters: percentageDelimiters, // Helper uses % to draw color zones
      arcLabels: absoluteDelimiters.map(v => v.toFixed(1)), // Helper uses snapped absolute values for labels
      hasNeedle: true,
      needleColor: this.getNeedleColor(value, absoluteDelimiters),
      rangeLabel: item.rangelabel || ['0', '100']
    };

    // Debug log to verify values are snapped (e.g., 2.5 instead of 2.52)
    console.log(`Gauge ${gauge.name} Labels:`, gauge.options.arcLabels);
  }

  private resetActiveGauge(): void {
    const activeGauge = this.machineVibration.find(gauge => gauge.isActive);
    if (activeGauge) {
      activeGauge.value = null;
      activeGauge.bottomLabel = '0';
      activeGauge.options = {
        ...this.getDefaultGaugeOptions(),
        hasNeedle: false,
        needleColor: '#cecece'
      };
    }
  }

  isAxisActive(axis: string): boolean {
    return this.selectedAxis === axis;
  }

  async fetchTemperatureGaugeData() {
    try {
      // this.loadingTemperature = true;

      // Check if temperature sensor is added
      if (this.data?.isTemperatureAdded !== "1") {
        console.log('Temperature sensor not added');
        this.resetTemperatureGauge();
        return;
      }

      // Use temperature channel from data
      const temperatureChannel = this.data.temperatureChannels?.[0]; // Get first temperature channel
      if (!temperatureChannel) {
        console.warn('No temperature channel found');
        this.resetTemperatureGauge();
        return;
      }

      const apiUrl = `${BaseUrlConstantsService.GET_PIEZO_TEMPERATURE_GAUGE}${this.clientId}/${temperatureChannel}/${this.data.assetId}`;
      const temperatureResponse: any = await this.service.getDataV2(apiUrl);


      if (temperatureResponse?.error === false && temperatureResponse?.data) {
        const tempData = temperatureResponse.data[0];
        const tempValue = parseFloat(tempData.value) || 0;
        const maxRange = parseFloat(tempData.rangelabel[1]) || 100;


        this.temperature = {
          ...this.temperature,
          value: tempValue.toFixed(1),
          bottomLabel: `${tempValue.toFixed(1)} ${'°C'}`,
          name: tempData.name === 'x' ? 'Bearing Temperature' : tempData.name === 'y' ? 'Winding Temperature' : 'Ambient Temperature',
          options: {
            arcColors: ['#74fa18', '#faa700', '#f3291c'],
            arcDelimiters: tempData.arcDelimiters, // Convert to percentage
            arcLabels: tempData.arcDelimiters || [60, 80], // Keep actual values for display
            hasNeedle: true,
            needleColor: this.getNeedleColor(tempValue, tempData.arcDelimiters),
            rangeLabel: tempData.rangelabel || ['0', '100']
          }
        };

      } else {
        this.resetTemperatureGauge();
      }
    } catch (error) {
      console.error('Error fetching temperature data:', error);
      this.resetTemperatureGauge();
    } finally {
      this.loadingTemperature = false;
    }
  }
  private resetTemperatureGauge(): void {
    this.temperature = {
      ...this.temperature,
      value: null,
      bottomLabel: 'N/A',
      options: {
        ...this.temperature.options,
        hasNeedle: false,
        needleColor: '#cecece'
      }
    };
  }

  private getNeedleColor(value: number, delimiters: number[]): string {
    if (!delimiters || delimiters.length < 2) {
      return '#cecece';
    }

    const numValue = parseFloat(value.toString()) || 0;
    const [lowLimit, highLimit] = delimiters;

    if (numValue <= lowLimit) {
      return '#72FF13'; // Green
    } else if (numValue > lowLimit && numValue <= highLimit) {
      return '#FAA700'; // Orange
    } else {
      return '#ff2a1b'; // Red
    }
  }

  async fetchBucketData() {
    try {
      // this.loadingBucket = true;

      const apiUrl = `${BaseUrlConstantsService.GET_PIEZO_BUCKET}${this.clientId}/${this.data.assetId}/12`;
      // const apiUrl = `http://localhost:9001/health-status-bar/${this.clientId}/${this.data.assetId}/12`;
      const bucketResponse: any = await this.service.getDataV2(apiUrl);


      if (bucketResponse?.error === false && Array.isArray(bucketResponse.data)) {
        const data = bucketResponse.data.slice(0, -1);
        this.bucketArray = data;

        // Map statuses from the new API format
        const healthy = data.map((d: any) => d.status === 'HEALTHY' ? 1 : 0);
        const unsatisfactory = data.map((d: any) => d.status === 'UNSATISFACTORY' ? 1 : 0);
        const unacceptable = data.map((d: any) => d.status === 'UNACCEPTABLE' ? 1 : 0);
        const idle = data.map((d: any) => d.status === 'IDLE' ? 1 : 0);
        const offline = data.map((d: any) => d.status === 'OFFLINE' || d.status === 'UNKNOWN' ? 1 : 0);

        this.healthStatusOptions = {
          ...this.healthStatusOptions,
          series: [
            { name: 'HEALTHY', data: healthy },
            { name: 'Unsatisfactory', data: unsatisfactory },
            { name: 'Unacceptable', data: unacceptable },
            { name: 'IDLE', data: idle },
            { name: 'OFFLINE', data: offline }
          ],
          colors: ['#74fa18', '#faa700', '#f3291c', '#999999', '#cecece'],
          xaxis: {
            categories: data.map((_, i) => i + 1),
            labels: { show: false },
            axisBorder: { show: false },
            axisTicks: { show: false }
          },
          tooltip: {
            theme: this.isDark ? 'dark' : 'light',
            custom: ({ series, seriesIndex, dataPointIndex, w }) => {
              const pointData = this.bucketArray[dataPointIndex];

              // Format metrics display
              let metricsHtml = '';
              if (pointData?.metrics) {
                const metricsObj = pointData.metrics;
                Object.keys(metricsObj).forEach(key => {
                  const metricValue = metricsObj[key];
                  if (metricValue !== null) {
                    metricsHtml += `<strong>Metric ${key}:</strong> ${metricValue}<br>`;
                  }
                });
              }
              function getStatusColor(status) {
                        switch (status) {
                          case "HEALTHY":
                            return "#72FF13"; // Green
                          case "UNSATISFACTORY":
                            return "#FAA700"; // Orange/Amber
                          case "UNACCEPTABLE":
                            return "#ff2a1b"; // Red
                          case "IDLE":
                            return "#cecece"; // idle
                          default:
                            return "#999999"; // Gray for unknown/undefined
                        }
                      }

                      // Color formatting for each status
                      const velocityColor = getStatusColor(
                        pointData.vibration_err_status,
                      );
                      const temperatureColor = getStatusColor(
                        pointData.temp_err_status,
                      );
              let final_string = `
              <div style="padding:8px; font-size:12px; min-width: 200px;">
                <strong>Time:</strong> ${pointData?.timestamp || 'N/A'}<br>
                <strong>Status:</strong> ${w.globals.seriesNames[seriesIndex]}<br>
                <strong>Velocity:</strong><span style="color:${velocityColor}; font-weight:bold"> ${pointData?.vibration_err_status !== null ? pointData.vibration_err_status : 'N/A'}</span><br>
            `
              if (this.BHEL_ON_PREM == false) {
                final_string += `<strong>Temperature:</strong><span style="color:${temperatureColor}; font-weight:bold"> ${pointData?.temp_err_status !== null ? pointData.temp_err_status : 'N/A'}</span><br>`
              }
              final_string += `</div>`
              return final_string;
            }
          }
        };

      } else {
        console.warn('No valid bucket data received');
        this.resetBucketChart();
      }
    } catch (error) {
      console.error('Error fetching bucket data:', error);
      this.resetBucketChart();
    } finally {
      this.loadingBucket = false;
    }
  }

  private resetBucketChart(): void {
    this.bucketArray = [];
    this.healthStatusOptions = {
      ...this.healthStatusOptions,
      series: [
        { name: 'HEALTHY', data: [] },
        { name: 'Unsatisfactory', data: [] },
        { name: 'Unacceptable', data: [] },
        { name: 'IDLE', data: [] },
        { name: 'OFFLINE', data: [] }
      ]
    };
  }


  async fetchAnomalyStatus() {
    try {
      // this.loadingAnomalyStatus = true;
      const apiUrl = `${BaseUrlConstantsService.GET_PIEZO_ANOMALY_STATUS}${this.clientId}/${this.data.assetId}`
      const anomalyResponse: any = await this.service.getDataV2(apiUrl);
      if (anomalyResponse?.error === false && anomalyResponse?.lastFileTime && anomalyResponse?.healthStatus) {
        this.anomalyStatus = anomalyResponse?.healthStatus;
        this.lastUpdatedAt = new ConvertDatetimePipe().convertDateTime(anomalyResponse?.lastFileTime);
        if (this.anomalyStatus === "HEALTHY") {
          this.recommendedAction = "No Action Required";
          this.actionClass = "text-green";
          this.anomalyActionClass = "status-pill--green"
        }
        else if (this.anomalyStatus === "UNHEALTHY") {
          this.recommendedAction = "Attention Required";
          this.actionClass = "text-orange";
          this.anomalyActionClass = "status-pill--orange"
        }
        else if (this.anomalyStatus === "ERROR") {
          this.recommendedAction = "Immediate Action Required";
          this.actionClass = "text-red";
          this.anomalyActionClass = "status-pill--red"
        }
      }
    }
    catch (error) {
      console.error('Error fetching anomaly status data:', error);
      this.resetTemperatureGauge();
    } finally {
      this.loadingAnomalyStatus = false;
    }
  }

  async fetchOperationalSummary() {
    try {
      // this.loadingOperationalSummary = true;
      const apiUrl = `${BaseUrlConstantsService.GET_PIEZO_OPERATIONAL_SUMMARY}${this.clientId}/${this.data.assetId}/1`
      const operationalResponse: any = await this.service.getDataV2(apiUrl);
      if (operationalResponse?.error === false) {
        this.noOfStops = operationalResponse?.data?.utilization?.device?.no_of_stops || 0;
        this.machineUtilization = operationalResponse?.data?.utilization?.device?.device_utilization || 0;
        this.weeklyRunTime = operationalResponse?.data?.utilization?.device?.weekly_running_status || "00 H 00 M";
      }
    }
    catch (error) {
      console.error('Error fetching operational summary data:', error);
    } finally {
      this.loadingOperationalSummary = false;
    }
  }
  async fetchAlerts() {
    try {
      const apiUrl = `${BaseUrlConstantsService.GET_PIEZO_ALERTS}${this.clientId}/${this.data.assetId}/24`;
      // const apiUrl = `http://localhost:9001/alerts/${this.clientId}/${this.data.assetId}/1`;
      const alertResponse: any = await this.service.getDataV2(apiUrl);

      if (alertResponse?.error === false) {
        this.alerts = alertResponse.data
          .map((item: any) => ({
            category: item.category || 'Asset Health',
            details: item.error || 'No description',
            rawTime: new Date(item.time).getTime(),
            time: new ConvertDatetimePipe().convertDateTime(item.time),

            status: this.mapStatus(item.ack_time),
            statusColor: this.mapStatusColor(item.ack_time),
            device_raw_matric_id: item.device_raw_matric_id
          }))
          .sort((a: any, b: any) => b.rawTime - a.rawTime);
      }

    } catch (error) {
      console.error('Error fetching alerts:', error);
    } finally {
      this.loadingAlerts = false;
    }
  }

  async fetchCompanyDetails() {
    try {
      // this.loadingCompanyDetails = true;

      const apiUrl = `${BaseUrlConstantsService.MONITORING_DEVICE_DETAILS_API}${this.data.assetId}?userId=${this.clientId}&assetType=${this.data.assetType}`;
      const response: any = await this.service.getDataV2(apiUrl);

      if (response?.data?.status === "success") {
        this.companyName = response?.data?.body?.companyName?.company_name || "";
        this.siteName = response?.data?.body?.assetDetails.site_name || "";
        this.applicationName = response?.data?.body?.assetDetails.application_name || "";
        this.serialNumber = response?.data?.body?.assetDetails.motor_serial_no || "";
        this.assetName = response?.data?.body?.assetDetails.name || "";
      }

    } catch (error) {
      console.error("Error fetching company details:", error);
    } finally {
      this.loadingCompanyDetails = false;
    }
  }

  async fetchServiceData() {
    // this.loadingServiceData = true;

    try {
      const apiUrl = `${BaseUrlConstantsService.BASE_ASSET_SERVICE}/${this.data.assetId}/${this.data.macAddress}?userid=${this.clientId}&asset_type=${this.data.assetType}`;
      const response: any = await this.service.getDataV2(apiUrl);

      if (response?.data?.status === "success" && response?.data?.body) {

        const body = response.data.body;

        // Use the Angular pipe properly
        const converter = new ConvertDatetimePipe();

        this.lastServiceDate = body.last_service_date
          ? converter.convertDateTime(body.last_service_date)
          : "N/A";

        this.servicePerformed = body.service_performed_by || "N/A";

        this.nextServiceDate = body.next_service_date
          ? converter.convertDateTime(body.next_service_date)
          : "N/A";
      } else {
        // fallback if no data returned
        this.lastServiceDate = "N/A";
        this.servicePerformed = "N/A";
        this.nextServiceDate = "N/A";
      }

    } catch (error) {
      console.error("Error fetching service details:", error);

      // fallback on error
      this.lastServiceDate = "N/A";
      this.servicePerformed = "N/A";
      this.nextServiceDate = "N/A";

    } finally {
      this.loadingServiceData = false;
    }
  }


  mapCategory(metricId: number): string {
    if (!metricId) return "Unknown";

    if ([19968666, 19968654].includes(metricId)) return "Ultrasound";
    if (metricId >= 40 && metricId <= 45) return "Vibration";
    if (metricId >= 46 && metricId <= 48) return "Temperature";
    return "General";
  }


  // --- STATUS LOGIC ---
  mapStatus(ackTime: string): string {
    return ackTime ? "Acknowledged" : "New";
  }

  mapStatusColor(ackTime: string): string {
    return ackTime ? "text-green" : "text-red";
  }



  toggleTheme(): void {
    this.isDark = !this.isDark;

    const legendColors = this.isDark
      ? ['#74fa18', '#faa700', '#f3291c', '#999999', '#cecece']
      : ['#74fa18', '#faa700', '#f3291c', '#999999', '#cecece'];

    this.healthStatusOptions = {
      ...this.healthStatusOptions,
      tooltip: {
        ...this.healthStatusOptions.tooltip,
        theme: this.isDark ? 'dark' : 'light'
      },
      legend: {
        ...this.healthStatusOptions.legend,
        markers: {
          ...this.healthStatusOptions.legend.markers,
          fillColors: legendColors
        },
        labels: {
          colors: this.isDark ? '#ccc' : '#333'
        }
      }
    };

    // Update trends charts theme if they exist
    if (this.showTrendsChart) this.fetchAllTrendsData();
  }

  private updateTrendsTheme(): void {
    const chartTypes = ['velocity', 'acceleration', 'displacement', 'temperature'];

    chartTypes.forEach(chartType => {
      if (this.trendsData[chartType]) {
        this.trendsData[chartType] = {
          ...this.trendsData[chartType],
          grid: {
            ...this.trendsData[chartType].grid,
            borderColor: this.isDark ? '#444' : '#e0e0e0'
          },
          xaxis: {
            ...this.trendsData[chartType].xaxis,
            labels: {
              ...this.trendsData[chartType].xaxis.labels,
              style: { colors: this.isDark ? '#ccc' : '#333' }
            }
          },
          yaxis: {
            ...this.trendsData[chartType].yaxis,
            title: {
              ...this.trendsData[chartType].yaxis.title,
              style: { color: this.isDark ? '#ccc' : '#333' }
            },
            labels: {
              ...this.trendsData[chartType].yaxis.labels,
              style: { colors: this.isDark ? '#ccc' : '#333' }
            }
          },
          tooltip: {
            ...this.trendsData[chartType].tooltip,
            theme: this.isDark ? 'dark' : 'light'
          },
          legend: {
            ...this.trendsData[chartType].legend,
            labels: { colors: this.isDark ? '#ccc' : '#333' }
          }
        };
      }
    });
  }

  // Helper methods for template
  isFilterActive(filter: string): boolean {
    return this.selectedFilter === filter;
  }


  handleTrends(): void {
    this.showTrendsChart = !this.showTrendsChart;
    if (this.showTrendsChart && !this.trendsData.velocity) {
      this.fetchAllTrendsData();
    }
  }

  async fetchAllTrendsData(): Promise<void> {
    const chartTypes = ['velocity', 'acceleration', 'displacement', 'temperature'];

    // Fetch all trends data concurrently
    const promises = chartTypes.map(chartType => this.fetchTrendData(chartType));
    await Promise.all(promises);
  }



  async fetchTrendData(chartType: string): Promise<void> {
    try {
      // this.trendsLoading[chartType] = true;

      // Get the appropriate channels based on chart type
      let channels = [];
      switch (chartType) {
        case 'velocity':
          channels = this.data.velocityChannels;
          break;
        case 'acceleration':
          channels = this.data.accelerationChannels;
          break;
        case 'displacement':
          channels = this.data.displacementChannels;
          break;
        case 'temperature':
          channels = this.data.temperatureChannels;
          break;
      }

      if (!channels || channels.length === 0) {
        console.warn(`No channels found for ${chartType}`);
        this.trendsData[chartType] = null;
        this.trendsLoading[chartType] = false;
        return;
      }

      const channelsParam = channels.join(',');
      const apiUrl = `${BaseUrlConstantsService.GET_PIEZO_TRENDS}${this.clientId}/${this.data.assetId}/${channelsParam}?type=${this.selectedTimeFilter}&startDate=${this.startDate}&endDate=${this.endDate}`;

      const response: any = await this.service.getDataV2(apiUrl);


      if (response?.error === false && response?.data?.chartdata) {
        this.trendsData[chartType] = this.processTrendData(response.data, chartType);
      } else {
        console.warn(`No valid ${chartType} trend data received`);
        this.trendsData[chartType] = null;
      }
    } catch (error) {
      console.error(`Error fetching ${chartType} trend data:`, error);
      this.trendsData[chartType] = null;
    } finally {
      this.trendsLoading[chartType] = false;
    }
  }



  private processTrendData(data: any, chartType: string): any {
    const { charts, thresholds } = data;

    if (!charts || !Array.isArray(charts) || charts.length === 0) {
      return null;
    }

    // Process series data for each axis (x, y, z)
    const series = charts.map((chart: any) => {
      const seriesData = chart.data.map((item: any) => ({
        x: new ConvertDatetimePipe().convertDateTime(item.x),
        y: item.y || 0
      }));

      return {
        name: `${this.getAxisLabel(chart.label)} - ${this.getYAxisTitle(chartType)}`,
        data: seriesData
      };
    });

    // Create threshold zones and annotations
    const annotationsYAxis = [];
    const green = thresholds?.green ? parseFloat(thresholds.green) : 0;
    const yellow = thresholds?.yellow ? parseFloat(thresholds.yellow) : 0;
    const red = thresholds?.red ? parseFloat(thresholds.red) : 100;

    // Green zone: 0 → green
    if (green > 0) {
      annotationsYAxis.push({
        y: 0,
        y2: green,
        fillColor: 'rgba(0, 255, 0, 0.3)',
        label: {
          text: green.toString(),
          position: 'right',
          offsetX: 0,
          style: {
            color: this.isDark ? '#ffffff' : '#333333',
            background: 'rgba(0, 255, 0, 0.8)',
            fontSize: '11px',
            fontWeight: 'bold',
            padding: {
              left: 6,
              right: 6,
              top: 2,
              bottom: 2
            }
          }
        }
      });
    }

    // Yellow zone: green → yellow
    if (yellow > green) {
      annotationsYAxis.push({
        y: green,
        y2: yellow,
        fillColor: 'rgba(255, 255, 0, 0.3)',
        label: {
          text: yellow.toString(),
          position: 'right',
          offsetX: 0,
          style: {
            color: '#333333',
            background: 'rgba(255, 255, 0, 0.8)',
            fontSize: '11px',
            fontWeight: 'bold',
            padding: {
              left: 6,
              right: 6,
              top: 2,
              bottom: 2
            }
          }
        }
      });
    }

    // Red zone: yellow → red
    if (red > yellow) {
      annotationsYAxis.push({
        y: yellow,
        y2: red,
        fillColor: 'rgba(255, 0, 0, 0.3)',
        label: {
          text: red.toString(),
          position: 'right',
          offsetX: 0,
          style: {
            color: '#ffffff',
            background: 'rgba(255, 0, 0, 0.8)',
            fontSize: '11px',
            fontWeight: 'bold',
            padding: {
              left: 6,
              right: 6,
              top: 2,
              bottom: 2
            }
          }
        }
      });
    }

    return {
      series: series,
      chart: {
        type: 'line',
        height: 400,
        width: '100%',
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: -15,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true
          }
        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800
        },
        background: 'transparent',
        zoom: {
          enabled: true,
        },
        fontFamily: 'inherit',
        foreColor: this.isDark ? '#ffffff' : '#333333'
      },
      colors: ['#2196F3', '#4CAF50', '#FF9800'], // Blue, Green, Orange for x, y, z
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      markers: {
        size: 0,
        hover: {
          size: 6,
        },
      },
      dropShadow: {
        enabled: true,
        top: 2,
        left: 2,
        blur: 4,
        opacity: 0.3
      },
      grid: {
        show: false
      },
      xaxis: {
        type: 'datetime',
        labels: {
          format: 'yyyy-MM-dd HH:mm:ss',
          datetimeUTC: false,
          rotate: -45,
          style: {
            fontSize: '11px',
            color: this.isDark ? '#ffffff' : '#333333',
          }
        }
      },
      yaxis: {
        min: 0,
        max: red,
        tickAmount: 6,
        forceNiceScale: true,
        title: {
          text: this.getYAxisTitle(chartType),
          style: {
            color: this.isDark ? '#ffffff' : '#333333',
            fontSize: '14px',
            fontWeight: 600
          }
        },
        labels: {
          formatter: (val: number) => val?.toFixed(2) || '0',
          style: {
            colors: this.isDark ? '#ffffff' : '#333333'
          }
        }
      },
      tooltip: {
        enabled: true,
        shared: true,
        intersect: false,
        followCursor: false,
        theme: this.isDark ? 'dark' : 'light',
        style: {
          fontSize: '12px',
          fontFamily: 'inherit'
        },
        x: {
          format: 'yyyy-MM-dd HH:mm:ss',
          formatter: function (val: number) {
            const date = new Date(val);
            return date.toLocaleString();
          }
        },
        y: {
          formatter: function (val: number) {
            return `${val?.toFixed(2) || '0'} ${this.getUnitSymbol ? this.getUnitSymbol(chartType) || '' : ''}`;
          }.bind(this),
          title: {
            formatter: (seriesName: string) => seriesName
          }
        },
        marker: {
          show: true
        },
        items: {
          display: 'flex'
        },
        fixed: {
          enabled: false,
          position: 'topRight',
          offsetX: 0,
          offsetY: 0
        }
      },
      annotations: {
        yaxis: annotationsYAxis,
        xaxis: [],
        points: []
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        labels: {
          colors: this.isDark ? '#ffffff' : '#333333'
        }
      },
      theme: {
        mode: this.isDark ? 'dark' : 'light',
        palette: 'palette8',
      },
      dataLabels: {
        enabled: false
      },
      plotOptions: {
        area: {
          fillTo: 'origin'
        }
      },
      responsive: [
        {
          breakpoint: 1024,
          options: {
            chart: {
              height: 350
            },
            legend: {
              position: 'bottom',
              offsetY: 0
            }
          }
        },
        {
          breakpoint: 768,
          options: {
            chart: {
              height: 300
            },
            legend: {
              position: 'bottom',
              offsetY: 0
            },
            xaxis: {
              labels: {
                rotate: -90,
                rotateAlways: true
              }
            }
          }
        },
        {
          breakpoint: 480,
          options: {
            chart: {
              height: 250
            },
            legend: {
              show: false
            }
          }
        }
      ]
    };
  }

  // Add this new helper method to get axis labels
  private getAxisLabel(axis: string): string {
    switch (axis?.toLowerCase()) {
      case 'x':
        return 'Radial (X)';
      case 'y':
        return 'Tangential (Y)';
      case 'z':
        return 'Axial (Z)';
      default:
        return axis?.toUpperCase() || 'Unknown';
    }
  }

  private getYAxisTitle(chartType: string): string {
    switch (chartType) {
      case 'velocity':
        return 'Velocity (mm/s)';
      case 'acceleration':
        return 'Acceleration (mm/s²)';
      case 'displacement':
        return 'Displacement (mm)';
      case 'temperature':
        return 'Temperature (°C)';
      default:
        return 'Value';
    }
  }

  private getUnitSymbol(chartType: string): string {
    switch (chartType) {
      case 'velocity':
        return 'mm/s';
      case 'acceleration':
        return 'mm/s²';
      case 'displacement':
        return 'mm';
      case 'temperature':
        return '°C';
      default:
        return '';
    }
  }

  getTrendChartTitle(chartType: string): string {
    return `${chartType.charAt(0).toUpperCase() + chartType.slice(1)} Trends`;
  }

  changeTimeFilter(filter: string) {
    this.selectedTimeFilter = filter;
    this.fetchAllTrendsData();
  }

  applyDateFilter() {
    if (this.startDate && this.endDate) {
      // 1. Create the Date objects
      const startObj = new Date(this.startDate);
      const endObj = new Date(this.endDate);

      // 2. Convert them back to strings (ISO format is best for APIs)
      this.startDate = startObj.toISOString();
      this.endDate = endObj.toISOString();

      // Alternative: If your API only wants YYYY-MM-DD, use this instead:
      // this.startDate = startObj.toISOString().split('T')[0];
      // this.endDate = endObj.toISOString().split('T')[0];

      this.selectedTimeFilter = 'range';
      this.fetchAllTrendsData();
    }
  }

  private formatDate(date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  OnClickAlert(report) {
    console.log("Report: ->", report)
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "400px",
      maxWidth: "85vw",
      data: {
        type: "AlertBookOpen",
        data: {
          assetid: this.data.assetId,
          clientid: this.clientId,
          report: report,
        },
      },
    });
  }

  OnClickTimeStamp(alert: any) {
    if (alert && alert.device_raw_matric_id) {
      sessionStorage.setItem('FFTId', alert.device_raw_matric_id);
      this.navigateToTab.emit('tab-2');
    }
    else {
      console.warn("No FFT ID associated with this alert");
    }
  }

  async openServiceModal() {
    try {
      this.loadingService = true;
      const apiUrl = `${BaseUrlConstantsService.BASE_ASSET_SERVICE}/${this.data.assetId}/${this.data.macAddress}`;
      const response: any = await this.service.getDataV2(apiUrl);
      if (response?.data?.status === "success") {
        this.serviceData = response.data.body;
        const dialogRef = this.dialog.open(ServiceStatusSettingsComponent, {
          width: '800px',
          disableClose: true,
          data: {
            serviceData: this.serviceData,
            assetId: this.data.assetId,
            macAddress: this.data.macAddress,
            userId: this.clientId,
            inventoryId: this.data.inventoryId
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === true) {
            console.log("Service status updated successfully")
          }
        })
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.loadingService = false;
    }
  }

  openReportModal() {
    this.isReportModalOpen = true;
    this.resetProcessing();
    this.startReportGeneration();
  }

  closeReportModal() {
    if (!this.isLoading) {
      this.isReportModalOpen = false;
      this.clearTimers();
    }
  }

  startReportGeneration() {
    this.currentStep = 1;
    this.progressPercentage = 33;
    this.processingStepText = "Collecting Data";

    this.processingTimers.push(
      setTimeout(() => {
        this.currentStep = 2;
        this.progressPercentage = 66;
        this.processingStepText = "Performing Report Generation";
        this.callGenerateReportApi();
      }, 1000)
    );
  }

  callGenerateReportApi() {
    console.log(this.data)
    const body = {
      user_id: this.clientId,
      asset_id: this.data.assetId,
      inventory_id: this.data.inventoryId,
      fft_value: this.data.latestFFTId,
      timezone: localStorage.getItem("clientTimeZone") || "asia/kolkata",
      fftIdAdvance: '',
      subsystem_id: this.subsystemId
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: `${this.token}`,
      token: this.token,
      Timezone: localStorage.getItem("clientTimeZone") || "not available",
    };

    // TODO: Replace with your actual piezo report generation endpoint
    const reportUrl = `${this.report_generate}generate_piezo_report`;
    console.log(reportUrl)
    this.http
      .postData(reportUrl, body)
      .then((response) => {
        console.log("Piezo Report API Response:", response);

        this.SAONDEMANDRESPONSE = response;

        this.processingTimers.push(
          setTimeout(() => {
            this.currentStep = 3;
            this.progressPercentage = 100;
            this.processingStepText = "Report Generated";
            this.isLoading = false;
            this.today = new Date();
          }, 500)
        );
      })
      .catch((err) => {
        console.error("Error calling Piezo Report API:", err);
        this.clearTimers();
        this.isLoading = false;
        alert("Failed to generate report. Please try again.");
      });
  }

  resetProcessing() {
    this.clearTimers();
    this.currentStep = 1;
    this.progressPercentage = 33;
    this.processingStepText = "Collecting Data";
    this.isLoading = true;
  }

  clearTimers() {
    this.processingTimers.forEach((timer) => clearTimeout(timer));
    this.processingTimers = [];
  }

  downloadReport() {
    this.isDownloading = true;
    console.log("Downloading piezo report...");

    let url = this.SAONDEMANDRESPONSE?.data?.assetBody?.report_url;
    console.log("Report URL:", url);

    // TODO: Implement your download logic here
    let body: any = {
      key: url,
    };

    // Simulating download for now
    setTimeout(() => {
      this.isDownloading = false;
      console.log("Download complete");
    }, 2000);

    // Uncomment when ready:
    this.http
      .postData(`${this.assetServiceUrl}/download-report`, body)
      .then((res: any) => {
        const responseData = res?.data;

        if (responseData?.status === "success" && responseData?.pdfFilePath) {
          const link = document.createElement("a");
          link.href = responseData.pdfFilePath;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        this.isDownloading = false;
      })
      .catch((err) => {
        console.error("Download error:", err);
        this.isDownloading = false;
      });
  }

  previewReport() {
    console.log("Previewing piezo report...");
    let url = this.SAONDEMANDRESPONSE?.data?.assetBody?.report_url;

    if (!url) {
      alert("Report URL not available");
      return;
    }

    // TODO: Implement preview logic
    let body: any = {
      key: url,
    };

    this.http
      .postData(`${this.report_preview_generate}/pre-signed-url`, body)
      .then((res: any) => {
        if (res?.status === "success" && res?.body) {
          window.open(res.body, "_blank");
        }
      })
      .catch((err) => {
        console.error("Preview error:", err);
      });
  }
}
